import * as api from '../api'

//Action Creators
export const getUnits = () => async (dispatch) => {
  try {
    const { data } = await api.fetchUnits()
    dispatch({ type: 'FETCH_UNITS', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
